import { atom } from 'recoil';

export const agreementState = atom<string | undefined>({
  key: 'agreementState',
  default: undefined,
});
